import { normalizeMbi } from '../../utils/mbi';

// CreateIVRDto omits empty optional fields. The web form intentionally does not submit date of
// birth; clinic remains the existing tenant key and is still validated or forced by the backend.
export function buildIvrPayload({ firstName, lastName, medicareId, comment, documents, clinic }) {
  const payload = {
    patient: {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    },
  };
  if (medicareId.trim()) {
    payload.insurance = { medicareId: normalizeMbi(medicareId) };
  }
  if (comment.trim()) {
    payload.comment = comment.trim();
  }
  if (documents && documents.length > 0) {
    payload.documents = documents;
  }
  if (clinic) {
    payload.clinic = clinic;
  }
  return payload;
}
